import {Component, OnInit} from '@angular/core';
import {UsuariosCargosService} from "./usuarios-cargos.service";
import {UsuariosCargosModel} from "./usuarios-cargos.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare let swal: any;

@Component({
  selector: 'app-usuarios-cargos',
  templateUrl: './usuarios-cargos.component.html'
})
export class UsuariosCargosComponent extends Components implements OnInit {

  cargos: UsuariosCargosModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    protected translate: TranslateService,
    protected router: Router,
    private usuariosCargosService: UsuariosCargosService,
    public global: Global,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'usuarios'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.usuariosCargosService.getPaginacao(1, this.itensPorPagina)
      .subscribe(data => {
        this.cargos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

          if (this.global.debug) {
            console.log(this.cargos);
          }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });

  }

  delete(cargo) {
    let cargos = this.cargos;
    let usuariosCargosService = this.usuariosCargosService;

    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarUnidade')+cargo.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(cargos);
        }

        let index = cargos.indexOf(cargo);
        cargos.splice(index, 1);

        usuariosCargosService.apagar(cargo.id)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.cargos = cargos;
            },
            err => {
              // Revert the view back to its original state
              cargos.splice(index, 0, cargo);
              self.cargos = cargos;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.usuariosCargosService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.cargos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
          this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarios-cargos/usuarios-cargos.component.ts